import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { trackDashboardCtaClicked } from "analytics";
import { PATHS } from "constants/pathConstants";
import { selectSpouseInformation } from "store/reducers/user/UserAccountSlice";
import NextMoveCard from ".";
import { SHOW_ALL_NEXT_MOVE_CARDS } from "./showAllNextMoveCards";
import Translate from "translate/Translate";

const InviteSpouseNextMoveCard = () => {
  const history = useHistory();
  const spouseAccessCode = useSelector(selectSpouseInformation)
    ?.spouseAccessCode;

  if (!SHOW_ALL_NEXT_MOVE_CARDS && !spouseAccessCode) {
    return null;
  }

  return (
    <NextMoveCard
      id="invite-spouse-next-move"
      title={<Translate text="Invite your spouse" />}
      body={
        <Translate text="Your spouse (or domestic partner) is enrolled but hasn't activated their online account. Creating their account—and accessing all that Genomic Life has to offer—is easy." />
      }
      subBody={
        <Translate text="Visit your dashboard, copy their access code, and share it with them. That's all they need to create their own account at member.genomiclife.com." />
      }
      link={{
        onClick: () => {
          trackDashboardCtaClicked({
            workflow: "spouse_invite",
            ctaLocation: "next_move_card",
            ctaId: "invite_spouse"
          });
          history.push(PATHS.ACCOUNT_MANAGEMENT_PAYMENT_INFORMATION);
        },
        overrideClick: true,
        url: PATHS.ACCOUNT_MANAGEMENT_PAYMENT_INFORMATION
      }}
    />
  );
};

export default InviteSpouseNextMoveCard;
